<template>
  <b-button
    class="close-modal-button"
    variant="outline"
    ref="btnHide"
    @click="$emit('clickButton')"
    ><b-icon-x font-scale="2"></b-icon-x
  ></b-button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.close-modal-button {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 0.75rem !important;

  &:hover {
    border: $border-header;
  }
}
</style>